/* Organik — product stage, sticky buy bar, quick buy */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function bagCount() {
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-bag-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function addVariant(id, label, done) {
    var text = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (label) label.textContent = 'Added';
        bagCount();
        setTimeout(function () { if (label) label.textContent = text; }, 1800);
        if (done) done(true);
      })
      .catch(function () {
        if (label) label.textContent = 'Try again';
        setTimeout(function () { if (label) label.textContent = text; }, 2200);
        if (done) done(false);
      });
  }

  /* ---- quick buy on cards and routine minis ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-buy]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addVariant(btn.getAttribute('data-quick-buy'), btn.querySelector('[data-quick-label]'));
  });

  /* ---- product image stage ---- */
  document.querySelectorAll('[data-stage]').forEach(function (stage) {
    var frames = Array.prototype.slice.call(stage.querySelectorAll('[data-frame]'));
    var dots = Array.prototype.slice.call(stage.querySelectorAll('[data-dot]'));
    if (frames.length < 2) return;
    var index = 0;

    function show(next) {
      index = (next + frames.length) % frames.length;
      frames.forEach(function (f, i) { f.setAttribute('data-active', i === index ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    stage.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-dir]');
      if (nav) {
        show(index + (nav.getAttribute('data-dir') === 'next' ? 1 : -1));
        return;
      }
      var dot = e.target.closest('[data-dot]');
      if (dot) show(parseInt(dot.getAttribute('data-dot'), 10));
    });

    var startX = null;
    stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
      startX = null;
    });
  });

  /* ---- sticky buy bar ---- */
  var sticky = document.querySelector('[data-sticky-buy]');
  var anchor = document.querySelector('.buyrow');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.setAttribute('data-shown', entry.isIntersecting ? 'false' : 'true');
      });
    }, { rootMargin: '0px 0px -20% 0px' }).observe(anchor);

    var stickyBtn = sticky.querySelector('[data-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('[data-variant-form] form');
        var idField = form && form.querySelector('[name="id"]');
        if (idField) addVariant(idField.value, stickyBtn);
      });
    }
  }

  /* ---- keep the in-stock note in sync with the chosen variant ---- */
  document.querySelectorAll('[data-variant-form]').forEach(function (panel) {
    var data = panel.querySelector('[data-variant-json]');
    var stock = panel.querySelector('[data-stock]');
    if (!data || !stock) return;
    var variants = JSON.parse(data.textContent);
    panel.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var chosen = Array.prototype.map.call(
        panel.querySelectorAll('[data-option]:checked'),
        function (i) { return i.value; }
      );
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      if (match) stock.textContent = match.available ? 'In stock' : 'Sold out';
    });
  });

  /* ---- close filter dropdowns on outside click ---- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.filterbar details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
})();

/* compare slider */
(function () {
  document.querySelectorAll('[data-compare]').forEach(function (box) {
    var input = box.querySelector('[data-compare-input]');
    if (!input) return;
    function paint() { box.style.setProperty('--pos', input.value + '%'); }
    input.addEventListener('input', paint);
    paint();
  });
})();
